const listingOptionsSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="511.625px" height="511.627px" viewBox="0 0 511.625 511.627" enable-background="new 0 0 511.625 511.627"
	 xml:space="preserve">
<g>
	<g>
		<path fill="#FFFFFF" d="M63.953,164.453H9.135c-2.474,0-4.615,0.9-6.423,2.709C0.903,168.972,0,171.114,0,173.589v54.817
			c0,2.473,0.902,4.619,2.712,6.424c1.809,1.803,3.949,2.712,6.423,2.712h54.818c2.474,0,4.614-0.904,6.423-2.712
			c1.809-1.809,2.712-3.951,2.712-6.424v-54.817c0-2.475-0.904-4.616-2.712-6.427C68.568,165.356,66.427,164.453,63.953,164.453z"/>
		<path fill="#FFFFFF" d="M63.953,383.722H9.135c-2.474,0-4.615,0.896-6.423,2.707C0.903,388.238,0,390.379,0,392.854v54.82
			c0,2.471,0.902,4.608,2.712,6.42c1.809,1.813,3.949,2.714,6.423,2.714h54.818c2.474,0,4.614-0.903,6.423-2.714
			c1.809-1.808,2.712-3.949,2.712-6.42v-54.82c0-2.477-0.904-4.616-2.712-6.426C68.568,384.625,66.427,383.722,63.953,383.722z"/>
		<path fill="#FFFFFF" d="M63.953,274.082H9.135c-2.474,0-4.615,0.91-6.423,2.714C0.904,278.6,0,280.749,0,283.22v54.814
			c0,2.479,0.902,4.62,2.712,6.428c1.809,1.808,3.949,2.707,6.423,2.707h54.818c2.474,0,4.614-0.896,6.423-2.707
			c1.809-1.808,2.712-3.949,2.712-6.428V283.22c0-2.472-0.904-4.613-2.712-6.425C68.568,274.989,66.427,274.082,63.953,274.082z"/>
		<path fill="#FFFFFF" d="M63.953,54.817H9.135c-2.474,0-4.615,0.903-6.423,2.712C0.904,59.338,0,61.479,0,63.953v54.817
			c0,2.475,0.902,4.615,2.712,6.424c1.809,1.809,3.949,2.712,6.423,2.712h54.818c2.474,0,4.614-0.9,6.423-2.712
			c1.809-1.809,2.712-3.949,2.712-6.424V63.953c0-2.475-0.904-4.615-2.712-6.424C68.568,55.725,66.427,54.817,63.953,54.817z"/>
		<path fill="#FFFFFF" d="M502.49,383.722H118.771c-2.474,0-4.615,0.896-6.423,2.707c-1.809,1.81-2.712,3.949-2.712,6.426v54.82
			c0,2.471,0.903,4.608,2.712,6.42c1.809,1.813,3.946,2.714,6.423,2.714H502.49c2.479,0,4.616-0.903,6.427-2.714
			c1.811-1.812,2.711-3.949,2.711-6.42v-54.82c0-2.477-0.903-4.616-2.711-6.426C507.106,384.625,504.967,383.722,502.49,383.722z"/>
		<path fill="#FFFFFF" d="M502.49,274.082H118.771c-2.474,0-4.615,0.91-6.423,2.714c-1.808,1.805-2.712,3.953-2.712,6.425v54.814
			c0,2.479,0.903,4.62,2.712,6.428s3.946,2.707,6.423,2.707H502.49c2.479,0,4.616-0.896,6.427-2.707
			c1.811-1.808,2.711-3.949,2.711-6.428V283.22c0-2.472-0.903-4.613-2.711-6.425C507.106,274.992,504.967,274.082,502.49,274.082z"
			/>
		<path fill="#FFFFFF" d="M508.916,57.529c-1.811-1.805-3.948-2.712-6.427-2.712H118.771c-2.474,0-4.615,0.903-6.423,2.712
			s-2.712,3.949-2.712,6.424v54.817c0,2.475,0.903,4.615,2.712,6.424s3.946,2.712,6.423,2.712H502.49c2.479,0,4.616-0.9,6.427-2.712
			c1.811-1.809,2.711-3.949,2.711-6.424V63.953C511.625,61.479,510.723,59.338,508.916,57.529z"/>
		<path fill="#FFFFFF" d="M502.49,164.453H118.771c-2.474,0-4.615,0.9-6.423,2.709c-1.809,1.811-2.712,3.952-2.712,6.427v54.817
			c0,2.473,0.903,4.615,2.712,6.424c1.809,1.803,3.946,2.712,6.423,2.712H502.49c2.479,0,4.616-0.904,6.427-2.712
			c1.811-1.809,2.711-3.951,2.711-6.424v-54.817c0-2.475-0.903-4.616-2.711-6.427C507.106,165.356,504.967,164.453,502.49,164.453z"
			/>
	</g>
</g>
</svg>
`;

export default listingOptionsSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/listingOptionsSVG.js